import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/printer-black.svg'
import _imports_1 from '@/app/ui/assets/svg/check_circle.svg'
import _imports_2 from '@/app/ui/assets/svg/check-silver-circle.svg'
import _imports_3 from '@/app/ui/assets/svg/ics_f_kg_circle.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-2a0471c4")

_pushScopeId("data-v-2a0471c4")
const _hoisted_1 = { class: "overflow-y-auto" }
const _hoisted_2 = {
  key: 0,
  class: "mx-6 mt-4"
}
const _hoisted_3 = { class: "mx-6 bg-white p-4 rounded-lg my-4" }
const _hoisted_4 = { class: "p-4 border border-gray-lp-1400 rounded-lg mb-4" }
const _hoisted_5 = { class: "flex justify-between items-center pb-4 mb-4 border-b border-b-gray-lp-800" }
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = { class: "flex pr-4" }
const _hoisted_8 = { class: "text-14px" }
const _hoisted_9 = { class: "ml-1 text-14px font-semibold" }
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "mx-1" }, "•", -1)
const _hoisted_11 = { class: "text-14px text-gray-lp-800" }
const _hoisted_12 = {
  key: 0,
  class: "flex pl-4 border-l border-l-gray-lp-800"
}
const _hoisted_13 = { class: "text-14px" }
const _hoisted_14 = { class: "ml-1 text-14px font-semibold" }
const _hoisted_15 = /*#__PURE__*/_createVNode("span", { class: "mx-1" }, "•", -1)
const _hoisted_16 = { class: "text-14px text-gray-lp-800" }
const _hoisted_17 = {
  key: 0,
  class: "bg-yellow-lp-200 text-yellow-lp-100 px-2 rounded-full"
}
const _hoisted_18 = {
  key: 1,
  class: "bg-red-lp-600 text-red-lp-100 px-2 rounded-full"
}
const _hoisted_19 = {
  key: 2,
  class: "bg-gray-lp-200 px-2 rounded-full"
}
const _hoisted_20 = { class: "w-full flex" }
const _hoisted_21 = {
  key: 0,
  class: "w-full pr-4 border-r border-l-gray-lp-1400"
}
const _hoisted_22 = { class: "flex gap-1 mb-2" }
const _hoisted_23 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "printer icon",
  class: "w-5"
}, null, -1)
const _hoisted_24 = { class: "font-semibold text-16px whitespace-nowrap" }
const _hoisted_25 = { class: "flex gap-2" }
const _hoisted_26 = {
  key: 0,
  src: _imports_1,
  alt: "check icon",
  class: "w-5"
}
const _hoisted_27 = {
  key: 1,
  src: _imports_2,
  alt: "check icon",
  class: "w-4"
}
const _hoisted_28 = { class: "flex gap-1 mb-2" }
const _hoisted_29 = /*#__PURE__*/_createVNode("img", {
  src: _imports_3,
  alt: "printer icon",
  class: "w-5"
}, null, -1)
const _hoisted_30 = { class: "font-semibold text-16px whitespace-nowrap" }
const _hoisted_31 = { class: "flex gap-2" }
const _hoisted_32 = {
  key: 0,
  src: _imports_1,
  alt: "check icon",
  class: "w-5"
}
const _hoisted_33 = {
  key: 1,
  src: _imports_2,
  alt: "check icon",
  class: "w-4"
}
const _hoisted_34 = {
  key: 0,
  class: "grid grid-cols-4 p-4 border border-gray-lp-1400 rounded-lg mb-4"
}
const _hoisted_35 = { class: "font-semibold" }
const _hoisted_36 = { class: "pl-4 border-l border-l-gray-lp-1400" }
const _hoisted_37 = { class: "font-semibold" }
const _hoisted_38 = { class: "pl-4 border-l border-l-gray-lp-1400" }
const _hoisted_39 = { class: "font-semibold" }
const _hoisted_40 = { class: "pl-4 border-l border-l-gray-lp-1400" }
const _hoisted_41 = { class: "font-semibold" }
const _hoisted_42 = {
  key: 0,
  class: "pr-3 mr-4 border-r border-r-gray-lp-1400"
}
const _hoisted_43 = { class: "font-semibold" }
const _hoisted_44 = { class: "font-semibold" }
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { class: "pl-4 border-l border-l-gray-lp-1400" }
const _hoisted_47 = { class: "font-semibold" }
const _hoisted_48 = { class: "pl-4 border-l border-l-gray-lp-1400" }
const _hoisted_49 = { class: "font-semibold" }
const _hoisted_50 = { class: "grid grid-cols-4 gap-2" }
const _hoisted_51 = { class: "col-span-1 px-4 pt-6 bg-gray-lp-1000 border border-gray-lp-1400 rounded-lg" }
const _hoisted_52 = { class: "mb-4" }
const _hoisted_53 = { class: "font-bold text-16px" }
const _hoisted_54 = { class: "mb-5" }
const _hoisted_55 = { class: "text-gray-lp-800 mb-2" }
const _hoisted_56 = { class: "font-bold text-24px" }
const _hoisted_57 = { class: "text-gray-lp-800 text-14px font-bold" }
const _hoisted_58 = { class: "mb-5" }
const _hoisted_59 = { class: "text-gray-lp-800 mb-2" }
const _hoisted_60 = { class: "font-bold text-24px" }
const _hoisted_61 = { class: "text-gray-lp-800 text-14px font-bold" }
const _hoisted_62 = { class: "mb-5" }
const _hoisted_63 = { class: "text-gray-lp-800 mb-2" }
const _hoisted_64 = { class: "font-bold text-24px" }
const _hoisted_65 = { class: "text-gray-lp-800 text-14px font-bold" }
const _hoisted_66 = { class: "col-span-1 px-4 pt-6 bg-gray-lp-1000 border border-gray-lp-1400 rounded-lg" }
const _hoisted_67 = { class: "mb-4" }
const _hoisted_68 = { class: "font-bold text-16px" }
const _hoisted_69 = { class: "mb-5" }
const _hoisted_70 = { class: "text-gray-lp-800 mb-2" }
const _hoisted_71 = { class: "font-bold text-24px" }
const _hoisted_72 = { class: "text-gray-lp-800 text-14px font-bold" }
const _hoisted_73 = { class: "mb-5" }
const _hoisted_74 = { class: "text-gray-lp-800 mb-2" }
const _hoisted_75 = { class: "font-bold text-24px" }
const _hoisted_76 = { class: "text-gray-lp-800 text-14px font-bold" }
const _hoisted_77 = { class: "mb-5" }
const _hoisted_78 = { class: "text-gray-lp-800 mb-2" }
const _hoisted_79 = { class: "font-bold text-24px" }
const _hoisted_80 = { class: "text-gray-lp-800 text-14px font-bold" }
const _hoisted_81 = { class: "col-span-2 px-4 py-6 border border-gray-lp-1400 rounded-lg" }
const _hoisted_82 = { class: "mb-4" }
const _hoisted_83 = { class: "font-bold text-16px" }
const _hoisted_84 = { class: "grid grid-cols-2" }
const _hoisted_85 = { class: "mb-5" }
const _hoisted_86 = { class: "text-gray-lp-800 mb-2" }
const _hoisted_87 = { class: "font-bold text-24px" }
const _hoisted_88 = { class: "text-gray-lp-800 text-14px font-bold" }
const _hoisted_89 = { class: "mb-5" }
const _hoisted_90 = { class: "text-gray-lp-800 mb-2" }
const _hoisted_91 = { class: "font-bold text-24px" }
const _hoisted_92 = { class: "text-gray-lp-800 text-14px font-bold" }
const _hoisted_93 = { class: "grid grid-cols-2" }
const _hoisted_94 = { class: "mb-5" }
const _hoisted_95 = { class: "text-gray-lp-800 mb-2" }
const _hoisted_96 = { class: "font-bold text-24px" }
const _hoisted_97 = { class: "text-gray-lp-800 text-14px font-bold" }
const _hoisted_98 = { class: "mb-5" }
const _hoisted_99 = { class: "text-gray-lp-800 mb-2" }
const _hoisted_100 = { class: "font-bold text-24px" }
const _hoisted_101 = { class: "text-gray-lp-800 text-14px font-bold" }
const _hoisted_102 = /*#__PURE__*/_createVNode("span", { class: "text-gray-lp-800 text-24px font-bold" }, " / ", -1)
const _hoisted_103 = { class: "text-gray-lp-800 text-14px font-bold" }
const _hoisted_104 = { class: "grid grid-cols-2" }
const _hoisted_105 = { class: "" }
const _hoisted_106 = { class: "text-gray-lp-800 mb-2" }
const _hoisted_107 = { class: "font-bold text-24px" }
const _hoisted_108 = { class: "text-gray-lp-800 text-14px font-bold" }
const _hoisted_109 = { class: "" }
const _hoisted_110 = { class: "text-gray-lp-800 mb-2" }
const _hoisted_111 = { class: "font-bold text-24px" }
const _hoisted_112 = { class: "text-gray-lp-800 text-14px font-bold" }
const _hoisted_113 = {
  key: 0,
  class: "mt-5 w-full flex gap-1 items-center"
}
const _hoisted_114 = { class: "text-blue-lp-700 underline decoration-blue-lp-700 underline-offset-1" }
const _hoisted_115 = { class: "mx-6 bg-white p-4 rounded-lg mb-6" }
const _hoisted_116 = { class: "flex flex-col items-start break-all text-left" }
const _hoisted_117 = { class: "flex gap-x-2 items-center font-normal text-black-lp-300 whitespace-normal break-all" }
const _hoisted_118 = { key: 0 }
const _hoisted_119 = /*#__PURE__*/_createVNode("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createVNode("path", {
    d: "M6.95813 6.73755C6.95813 6.36257 6.65415 6.05859 6.27918 6.05859C5.9042 6.05859 5.60022 6.36257 5.60022 6.73755V10.617C5.60022 10.992 5.9042 11.296 6.27918 11.296C6.65415 11.296 6.95813 10.992 6.95813 10.617V9.61366L7.61164 10.9207C7.77934 11.2561 8.18717 11.392 8.52256 11.2243C8.85795 11.0566 8.99389 10.6488 8.8262 10.3134L7.88788 8.43677L8.68506 7.68404C8.9577 7.4266 8.97002 6.99688 8.71258 6.72424C8.45514 6.4516 8.02542 6.43928 7.75278 6.69672L6.95813 7.44707V6.73755Z",
    fill: "#FF0000"
  }),
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M11.0328 9.90602V10.3587C11.0328 10.4836 10.9315 10.585 10.8065 10.585H10.16C9.78501 10.585 9.48103 10.889 9.48103 11.2639C9.48103 11.6389 9.78501 11.9429 10.16 11.9429H10.8065C11.6815 11.9429 12.3907 11.2336 12.3907 10.3587V8.09547C12.3907 7.22006 11.6805 6.51123 10.806 6.51123C9.93155 6.51123 9.22133 7.22006 9.22133 8.09547V8.32178C9.22133 9.19673 9.93061 9.90602 10.8056 9.90602H11.0328ZM10.806 7.86915C10.6806 7.86915 10.5792 7.97093 10.5792 8.09547V8.32178C10.5792 8.44678 10.6806 8.5481 10.8056 8.5481H11.0328V8.09547C11.0328 7.97093 10.9315 7.86915 10.806 7.86915Z",
    fill: "#FF0000"
  }),
  /*#__PURE__*/_createVNode("path", {
    d: "M14.9758 9.76377C15.0281 9.35294 15.4038 9.06234 15.8146 9.1146C16.2255 9.16696 16.5161 9.5425 16.4637 9.95339C15.9395 14.0663 12.1806 16.9755 8.06762 16.4515C4.93052 16.0517 2.49478 13.7704 1.74682 10.8881C1.64295 10.4872 1.88406 10.0779 2.28491 9.9739C2.68569 9.87006 3.09507 10.1105 3.19917 10.5113C3.79835 12.8203 5.74902 14.6439 8.25724 14.9635C11.5484 15.3828 14.5562 13.0549 14.9758 9.76377ZM1.56883 8.05525C2.09299 3.94208 5.8526 1.03238 9.96577 1.55654C13.0331 1.94754 15.4294 4.13736 16.2334 6.92857C16.3481 7.32661 16.1181 7.74233 15.7201 7.85697C15.3221 7.97148 14.9071 7.7417 14.7924 7.34374C14.1482 5.10727 12.2286 3.35715 9.77615 3.04451C6.48476 2.62507 3.47623 4.95348 3.05679 8.24487C3.0043 8.65561 2.6288 8.94639 2.218 8.89404C1.8072 8.84169 1.51663 8.46603 1.56883 8.05525Z",
    fill: "#FF0000"
  }),
  /*#__PURE__*/_createVNode("path", {
    d: "M0.953505 7.51979C0.741941 7.16368 0.859118 6.70349 1.21523 6.49193C1.57134 6.28037 2.03153 6.39754 2.24309 6.75365L2.59735 7.34996L3.07654 7.06527C3.43265 6.85371 3.89284 6.97089 4.1044 7.327C4.31576 7.68307 4.1987 8.14335 3.84268 8.35486L2.7187 9.02261C2.36268 9.23413 1.90247 9.1168 1.69084 8.76089L0.953505 7.51979Z",
    fill: "#FF0000"
  }),
  /*#__PURE__*/_createVNode("path", {
    d: "M17.1514 10.6365C17.3629 10.9926 17.2457 11.4528 16.8896 11.6643C16.5335 11.8759 16.0733 11.7587 15.8618 11.4026L15.3624 10.562L14.6615 10.9783C14.3054 11.1899 13.8452 11.0727 13.6337 10.7166C13.4224 10.3606 13.5394 9.90027 13.8954 9.68875L15.241 8.88932C15.597 8.67782 16.0572 8.79517 16.2689 9.15104L17.1514 10.6365Z",
    fill: "#FF0000"
  })
], -1)
const _hoisted_120 = { class: "text-red-lp-2400 underline decoration-blue-lp-700 underline-offset-1" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_CardFlightDetail = _resolveComponent("CardFlightDetail")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Title = _resolveComponent("Title")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_PreviewImagePod = _resolveComponent("PreviewImagePod")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      (_ctx.detailData.cargoType === 'plane' && !_ctx.$route.query.rc_no)
        ? (_openBlock(), _createBlock("div", _hoisted_2, [
            _createVNode(_component_CardFlightDetail, { flightDetailData: _ctx.detailData }, null, 8, ["flightDetailData"])
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("cargo.v2.detail.field.bookingDate")), 1),
                _createVNode("span", _hoisted_9, _toDisplayString(_ctx.bookingDate), 1),
                _hoisted_10,
                _createVNode("p", _hoisted_11, _toDisplayString(_ctx.detailData.createdBy), 1)
              ]),
              (_ctx.updateDate)
                ? (_openBlock(), _createBlock("div", _hoisted_12, [
                    _createVNode("p", _hoisted_13, _toDisplayString(_ctx.$t("cargo.v2.detail.field.lastUpdated")), 1),
                    _createVNode("span", _hoisted_14, _toDisplayString(_ctx.updateDate), 1),
                    _hoisted_15,
                    _createVNode("p", _hoisted_16, _toDisplayString(_ctx.detailData.updatedByName), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.isInProcess)
              ? (_openBlock(), _createBlock("div", _hoisted_17, [
                  _createVNode("p", null, _toDisplayString(_ctx.$t("cargo.v2.detail.badge.inProgress")), 1)
                ]))
              : _createCommentVNode("", true),
            (
              _ctx.detailData.cargoStatus === 'cancel' ||
                _ctx.detailData.cargoStatus === 'failed'
            )
              ? (_openBlock(), _createBlock("div", _hoisted_18, [
                  _createVNode("p", null, _toDisplayString(_ctx.$t("cargo.v2.detail.badge.cancelledFailed")), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.detailTrackingStatus && !_ctx.detailData.cargoStatus)
              ? (_openBlock(), _createBlock("div", _hoisted_19, [
                  _createVNode("p", null, _toDisplayString(_ctx.detailTrackingStatus), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_20, [
            (!_ctx.$route.query.rc_no)
              ? (_openBlock(), _createBlock("div", _hoisted_21, [
                  _createVNode("div", _hoisted_22, [
                    _hoisted_23,
                    _createVNode("p", _hoisted_24, _toDisplayString(_ctx.$t("cargoV2.components.detailInfo.printStatus")), 1)
                  ]),
                  _createVNode("div", _hoisted_25, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.printStatus, (item) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "flex items-center px-2 py-1 gap-2 bg-gray-lp-2800 whitespace-nowrap rounded-lg border border-gray-lp-1400",
                        key: item.label
                      }, [
                        (item.printed)
                          ? (_openBlock(), _createBlock("img", _hoisted_26))
                          : (_openBlock(), _createBlock("img", _hoisted_27)),
                        _createTextVNode(" " + _toDisplayString(item.label), 1)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", {
              class: `w-full ${!_ctx.$route.query.rc_no && 'ml-4'}`
            }, [
              _createVNode("div", _hoisted_28, [
                _hoisted_29,
                _createVNode("p", _hoisted_30, _toDisplayString(_ctx.$t("cargo.v2.detail.section.weightDispute")), 1)
              ]),
              _createVNode("div", _hoisted_31, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.disputeStatus, (item) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "flex items-center px-2 py-1 gap-2 bg-gray-lp-2800 whitespace-nowrap rounded-lg border border-gray-lp-1400",
                    key: item.printerName
                  }, [
                    (item.isPrinted)
                      ? (_openBlock(), _createBlock("img", _hoisted_32))
                      : (_openBlock(), _createBlock("img", _hoisted_33)),
                    _createTextVNode(" " + _toDisplayString(item.printerName), 1)
                  ]))
                }), 128))
              ])
            ], 2)
          ])
        ]),
        (_ctx.detailData.cargoType === 'plane')
          ? (_openBlock(), _createBlock("div", _hoisted_34, [
              _createVNode("div", null, [
                _createVNode("p", null, _toDisplayString(_ctx.$t("cargo.v2.detail.field.commodity")), 1),
                _createVNode("p", _hoisted_35, _toDisplayString(_ctx.detailData.cargoCommodity || "-"), 1)
              ]),
              _createVNode("div", _hoisted_36, [
                _createVNode("p", null, _toDisplayString(_ctx.$t("cargo.v2.detail.field.product")), 1),
                _createVNode("p", _hoisted_37, _toDisplayString(_ctx.detailData.cargoProduct || "-"), 1)
              ]),
              _createVNode("div", _hoisted_38, [
                _createVNode(_component_DataWrapper, {
                  label: "NOG",
                  tooltipDescription: _ctx.$t('cargo.v2.detail.tooltip.cargoNog'),
                  fontStyleLabel: "font-normal"
                }, {
                  default: _withId(() => [
                    _createVNode("p", _hoisted_39, _toDisplayString(_ctx.detailData.cargoNog || _ctx.detailData.nog || "-"), 1)
                  ]),
                  _: 1
                }, 8, ["tooltipDescription"])
              ]),
              _createVNode("div", _hoisted_40, [
                _createVNode(_component_DataWrapper, {
                  label: "SHC",
                  tooltipDescription: _ctx.$t('cargo.v2.detail.tooltip.shcCode'),
                  fontStyleLabel: "font-normal"
                }, {
                  default: _withId(() => [
                    _createVNode("p", _hoisted_41, _toDisplayString(_ctx.detailData.shcCode || "-"), 1)
                  ]),
                  _: 1
                }, 8, ["tooltipDescription"])
              ])
            ]))
          : (_openBlock(), _createBlock("div", {
              key: 1,
              class: `grid ${_ctx.detailData.cargoType === 'ship' ? 'grid-cols-4' : 'grid-cols-3'} p-4 border border-gray-lp-1400 rounded-lg mb-4`
            }, [
              (_ctx.detailData.cargoType === 'ship')
                ? (_openBlock(), _createBlock("div", _hoisted_42, [
                    _createVNode("p", null, _toDisplayString(_ctx.$t("cargo.labels.cargoNumberSmu")), 1),
                    _createVNode("p", _hoisted_43, _toDisplayString(_ctx.detailData.cargoNumber || '-'), 1)
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", null, [
                _createVNode("p", null, _toDisplayString(_ctx.$t("cargo.labels.vehicleSerialNumber")), 1),
                _createVNode("p", _hoisted_44, [
                  _createTextVNode(_toDisplayString(_ctx.detailData.vehiclePoliceNumber || "-") + " ", 1),
                  (_ctx.detailData.driverName)
                    ? (_openBlock(), _createBlock("span", _hoisted_45, " - " + _toDisplayString(_ctx.detailData.driverName), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode("div", _hoisted_46, [
                _createVNode("p", null, _toDisplayString(_ctx.$t("cargo.v2.detail.field.commodity")), 1),
                _createVNode("p", _hoisted_47, _toDisplayString(_ctx.detailData.cargoCommodity || "-"), 1)
              ]),
              _createVNode("div", _hoisted_48, [
                _createVNode("p", null, _toDisplayString(_ctx.$t("cargo.v2.detail.field.product")), 1),
                _createVNode("p", _hoisted_49, _toDisplayString(_ctx.detailData.cargoProduct || "-"), 1)
              ])
            ], 2)),
        _createVNode("div", _hoisted_50, [
          _createVNode("div", _hoisted_51, [
            _createVNode("div", _hoisted_52, [
              _createVNode("p", _hoisted_53, _toDisplayString(_ctx.$t("cargo.v2.detail.field.sttWeight")), 1)
            ]),
            _createVNode("div", _hoisted_54, [
              _createVNode("p", _hoisted_55, _toDisplayString(_ctx.$t("cargo.labels.grossWeight")), 1),
              _createVNode("p", _hoisted_56, [
                _createTextVNode(_toDisplayString(_ctx.convertDecimalWithComma(_ctx.detailData.totalGrossWeight)) + " ", 1),
                _createVNode("span", _hoisted_57, _toDisplayString(_ctx.$t("cargoV2.components.common.kg")), 1)
              ])
            ]),
            _createVNode("div", _hoisted_58, [
              _createVNode("p", _hoisted_59, _toDisplayString(_ctx.$t("cargo.labels.volumeWeight")), 1),
              _createVNode("p", _hoisted_60, [
                _createTextVNode(_toDisplayString(_ctx.convertDecimalWithComma(_ctx.detailData.totalVolumeWeight)) + " ", 1),
                _createVNode("span", _hoisted_61, _toDisplayString(_ctx.$t("cargoV2.components.common.kg")), 1)
              ])
            ]),
            _createVNode("div", _hoisted_62, [
              _createVNode("p", _hoisted_63, _toDisplayString(_ctx.$t("cargo.labels.chargeableWeightCargo")), 1),
              _createVNode("p", _hoisted_64, [
                _createTextVNode(_toDisplayString(_ctx.convertDecimalWithComma(_ctx.detailData.cargoTotalChargeableWeight)) + " ", 1),
                _createVNode("span", _hoisted_65, _toDisplayString(_ctx.$t("cargoV2.components.common.kg")), 1)
              ])
            ])
          ]),
          _createVNode("div", _hoisted_66, [
            _createVNode("div", _hoisted_67, [
              _createVNode("p", _hoisted_68, _toDisplayString(_ctx.$t("cargo.labels.grossWeightReweigh")), 1)
            ]),
            _createVNode("div", _hoisted_69, [
              _createVNode("p", _hoisted_70, _toDisplayString(_ctx.$t("cargo.labels.grossWeight")), 1),
              _createVNode("p", _hoisted_71, [
                _createTextVNode(_toDisplayString(_ctx.convertDecimalWithComma(_ctx.detailData.totalEstCargoGrossWeight)) + " ", 1),
                _createVNode("span", _hoisted_72, _toDisplayString(_ctx.$t("cargoV2.components.common.kg")), 1)
              ])
            ]),
            _createVNode("div", _hoisted_73, [
              _createVNode("p", _hoisted_74, _toDisplayString(_ctx.$t("cargo.labels.volumeWeight")), 1),
              _createVNode("p", _hoisted_75, [
                _createTextVNode(_toDisplayString(_ctx.convertDecimalWithComma(_ctx.detailData.totalEstCargoVolumeWeight)) + " ", 1),
                _createVNode("span", _hoisted_76, _toDisplayString(_ctx.$t("cargoV2.components.common.kg")), 1)
              ])
            ]),
            _createVNode("div", _hoisted_77, [
              _createVNode("p", _hoisted_78, _toDisplayString(_ctx.$t("cargo.labels.chargeableWeightCargo")), 1),
              _createVNode("p", _hoisted_79, [
                _createTextVNode(_toDisplayString(_ctx.convertDecimalWithComma(
                  _ctx.detailData.cargoTotalEstimateChargeableWeight
                )) + " ", 1),
                _createVNode("span", _hoisted_80, _toDisplayString(_ctx.$t("cargoV2.components.common.kg")), 1)
              ])
            ])
          ]),
          _createVNode("div", _hoisted_81, [
            _createVNode("div", _hoisted_82, [
              _createVNode("p", _hoisted_83, _toDisplayString(_ctx.$t("cargo.v2.detail.field.cargoWeight")), 1)
            ]),
            _createVNode("div", _hoisted_84, [
              _createVNode("div", _hoisted_85, [
                _createVNode("p", _hoisted_86, _toDisplayString(_ctx.$t("cargo.labels.grossWeight")), 1),
                _createVNode("p", _hoisted_87, [
                  _createTextVNode(_toDisplayString(_ctx.convertDecimalWithComma(
                    _ctx.detailData.totalActualCargoGrossWeight
                  )) + " ", 1),
                  _createVNode("span", _hoisted_88, _toDisplayString(_ctx.$t("cargoV2.components.common.kg")), 1)
                ])
              ]),
              _createVNode("div", _hoisted_89, [
                _createVNode("p", _hoisted_90, _toDisplayString(_ctx.$t("cargo.labels.cargoPieces")), 1),
                _createVNode("p", _hoisted_91, [
                  _createTextVNode(_toDisplayString(_ctx.convertDecimalWithComma(_ctx.detailData.cargoActualPiece)) + " ", 1),
                  _createVNode("span", _hoisted_92, _toDisplayString(_ctx.$t("cargo.labels.pieces")), 1)
                ])
              ])
            ]),
            _createVNode("div", _hoisted_93, [
              _createVNode("div", _hoisted_94, [
                _createVNode("p", _hoisted_95, _toDisplayString(_ctx.$t("cargo.labels.volumeWeight")), 1),
                _createVNode("p", _hoisted_96, [
                  _createTextVNode(_toDisplayString(_ctx.convertDecimalWithComma(
                    _ctx.detailData.totalActualCargoVolumeWeight
                  )) + " ", 1),
                  _createVNode("span", _hoisted_97, _toDisplayString(_ctx.$t("cargoV2.components.common.kg")), 1)
                ])
              ]),
              _createVNode("div", _hoisted_98, [
                _createVNode("p", _hoisted_99, _toDisplayString(_ctx.$t("cargoV2.components.detailInfo.totalSttBag")), 1),
                _createVNode("p", _hoisted_100, [
                  _createTextVNode(_toDisplayString(_ctx.convertDecimalWithComma(_ctx.detailData.onlyTotalStt)) + " ", 1),
                  _createVNode("span", _hoisted_101, _toDisplayString(_ctx.$t("cargoV2.components.detailInfo.stt")), 1),
                  _hoisted_102,
                  _createTextVNode(_toDisplayString(_ctx.convertDecimalWithComma(_ctx.detailData.onlyTotalBag)) + " ", 1),
                  _createVNode("span", _hoisted_103, _toDisplayString(_ctx.$t("cargoV2.components.detailInfo.bag")), 1)
                ])
              ])
            ]),
            _createVNode("div", _hoisted_104, [
              _createVNode("div", _hoisted_105, [
                _createVNode("p", _hoisted_106, _toDisplayString(_ctx.$t("cargo.labels.chargeableWeightCargo")), 1),
                _createVNode("p", _hoisted_107, [
                  _createTextVNode(_toDisplayString(_ctx.convertDecimalWithComma(
                    _ctx.detailData.cargoTotalCustomChargeableWeight
                  )) + " ", 1),
                  _createVNode("span", _hoisted_108, _toDisplayString(_ctx.$t("cargoV2.components.common.kg")), 1)
                ])
              ]),
              _createVNode("div", _hoisted_109, [
                _createVNode("p", _hoisted_110, _toDisplayString(_ctx.$t("cargo.labels.weightBagDifference")), 1),
                _createVNode("p", _hoisted_111, [
                  _createTextVNode(_toDisplayString(_ctx.convertDecimalWithComma(_ctx.detailData.totalBagWithWeightDispute)) + " ", 1),
                  _createVNode("span", _hoisted_112, _toDisplayString(_ctx.$t("cargoV2.components.detailInfo.bag")), 1)
                ])
              ])
            ]),
            (_ctx.detailData?.photoProof?.length)
              ? (_openBlock(), _createBlock("div", _hoisted_113, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listProofImageData, (item, index) => {
                    return (_openBlock(), _createBlock("div", {
                      key: index,
                      class: "p-1 rounded-lg w-16 h-16 flex items-center justify-center border border-gray-lp-1500 cursor-pointer"
                    }, [
                      _createVNode("img", {
                        src: item,
                        class: "w-full h-full object-cover rounded-lg",
                        alt: _ctx.$t('cargoV2.components.detailInfo.photoProofAlt', { index: index + 1 }),
                        onClick: _cache[1] || (_cache[1] = () => _ctx.onOpenPreviewPhotoProof(_ctx.detailData.photoProof))
                      }, null, 8, ["src", "alt"])
                    ]))
                  }), 128)),
                  _createVNode("div", {
                    class: "cursor-pointer",
                    onClick: _cache[2] || (_cache[2] = () => _ctx.onOpenPreviewPhotoProof(_ctx.detailData.photoProof))
                  }, [
                    _createVNode("p", _hoisted_114, _toDisplayString(_ctx.$t("cargo.v2.detail.action.viewPhotoProof", {
                    count: _ctx.detailData?.photoProof?.length - 2
                  })), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createVNode("div", _hoisted_115, [
        _createVNode(_component_Title, {
          label: _ctx.$t('cargo.labels.listSttBag'),
          fontColor: "text-black-lp-200",
          fontSize: 20,
          class: "mb-10"
        }, null, 8, ["label"]),
        _createVNode("div", {
          class: 
          `detail-cargo-detail pb-6 space-y-0 mt-4 ${
            _ctx.totalDisputeBagging > 0 ? 'pt-4' : ''
          }`
        
        }, [
          _createVNode(_component_TableV2, {
            data: _ctx.dataTable,
            columns: _ctx.columns,
            pagination: _ctx.pagination,
            hidePagination: "",
            borderTop: false,
            bgHeader: "bg-gray-lp-1200 border-t border-gray-lp-1400",
            borderRowColor: "border-white",
            isBorderOnHeadBgWhite: "",
            isEmpty: _ctx.isSttEmpty,
            emptyMessage: _ctx.$t('cargo.messages.noCargoItems'),
            groupAction: ""
          }, {
            no_bag: _withId(({ item }) => [
              _createVNode("div", _hoisted_116, [
                _createVNode("div", _hoisted_117, [
                  _createTextVNode(_toDisplayString(item.baggingVendorNumber || item.baggingNumber || "-") + " ", 1),
                  (
                    (item.baggingVendorNumber || item.baggingNumber) &&
                      item.isDisputeBagging
                  )
                    ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_118, [
                        _hoisted_119
                      ], 512)), [
                        [
                          _directive_tooltip,
                          _ctx.$t('cargo.labels.bagWithWeightDifference'),
                          void 0,
                          { bottom: true }
                        ]
                      ])
                    : _createCommentVNode("", true)
                ]),
                (item.bagPhotoProof.length > 0)
                  ? (_openBlock(), _createBlock("div", {
                      key: 0,
                      class: "cursor-pointer",
                      onClick: _withModifiers(() => _ctx.onOpenPreviewPhotoProof(item.bagPhotoProof), ["stop"])
                    }, [
                      _createVNode("p", _hoisted_120, _toDisplayString(_ctx.$t("cargo.v2.dispute.photo.viewProof")), 1)
                    ], 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["data", "columns", "pagination", "isEmpty", "emptyMessage"])
        ], 2)
      ])
    ]),
    (_ctx.isPreviewPhotoProof)
      ? (_openBlock(), _createBlock(_component_PreviewImagePod, {
          key: 0,
          data: _ctx.photoProofItems,
          onClose: () => _ctx.onClosePreviewPhotoProof()
        }, null, 8, ["data", "onClose"]))
      : _createCommentVNode("", true)
  ], 64))
})